/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap} from "gsap";
import {SerialGameAssets} from "../../../SerialGameAssets";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export class BigWinCountUp extends PIXI.Container {

    protected _countUp:BitmapCountUp;
    private _endingScale:number = 0.6;

    public set externalAlpha(value:number) {
        this._countUp.alpha = value;
    }
    public get externalAlpha():number {
        return this._countUp.alpha;
    }

    constructor() {
        super();

        const style = {
            fontName : SerialGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 70,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this.addChild(this._countUp);
    }

    public getCountUpAnimation(from:number, to:number, duration:number, layer:StageLayer, positionY:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add([
            () => {
                this.position.set(360, positionY);
                layer.addChild(this);
                this._countUp.maxTextWidth = 580;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            <gsap.core.Timeline><unknown>this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ]);

        return tl;
    }

    public stay():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this._countUp.scale, {
                duration : 0.5,
                x : this._endingScale,
                y : this._endingScale,
                ease : `elastic.out(1, 1)`
            }),
            gsap.to(this, {y : 300})
        ]);
        // timeline.add(() => ElPasoGunfightSoundConfig.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove():gsap.core.Timeline {
        const tl = gsap.timeline();
        if(this._countUp.visible) {
            tl.add(gsap.to(this._countUp, {duration : 0.5, alpha : 0, y : -100, ease : `power2.in`}), `+=0.2`); // stay a short while after count up.
            tl.add(() => {
                this._countUp.y = 0;
                this._countUp.visible = false;
            });
        }

        return tl;
    }
}